if (!customElements.get('scroll-to-section-bottom')) {
  class ScrollToSectionBottom extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
      e.preventDefault();
      
      const sectionId = this.getAttribute('section-id');
      if (!sectionId) return;

      const section = document.getElementById(sectionId);
      if (!section) return;

      const header = document.querySelector('.shopify-section--header');
      const announcementBar = document.querySelector('.shopify-section--announcement-bar');
      
      const headerHeight = header ? header.offsetHeight : 0;
      const announcementBarHeight = (announcementBar && 
        getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-is-sticky') === '1') 
        ? announcementBar.offsetHeight 
        : 0;
      
      const sectionBottom = section.offsetTop + section.offsetHeight - headerHeight - announcementBarHeight;
      
      window.scrollTo({ 
        top: sectionBottom, 
        behavior: 'smooth' 
      });
    }
  }

  customElements.define('scroll-to-section-bottom', ScrollToSectionBottom);
}

